<template>
  <VisionSidebar
    :visible="visible"
    title="Refine by"
    :fixed-title="true"
    @close="emit('close')"
    @block-body-scroll="handleBlockBodyScroll"
  >
    <div class="FilterFacetsSidebar__body-wrapper">
      <div
        v-if="props.facetsToDisplay.lensColour"
      >
        <ListRefinement
          :attribute="props.facetsToDisplay.lensColour"
          :title="props.facetsToDisplay.lensColour.filterGroupDisplayName"
          :group-value="props.facetsToDisplay.lensColour.filterGroupValue"
          :selected="
            activeFilterGroup ===
              props.facetsToDisplay.lensColour.filterGroupValue
          "
          dropdown-positioning="sidebar"
          @toggle-active-filter-group="toggleActiveFilterGroup"
        />
      </div>
      <div
        v-if="props.facetsToDisplay.frameColour"
      >
        <ListRefinement
          :attribute="props.facetsToDisplay.frameColour"
          :title="props.facetsToDisplay.frameColour.filterGroupDisplayName"
          :group-value="props.facetsToDisplay.frameColour.filterGroupValue"
          :selected="
            activeFilterGroup ===
              props.facetsToDisplay.frameColour.filterGroupValue
          "
          dropdown-positioning="sidebar"
          @toggle-active-filter-group="toggleActiveFilterGroup"
        />
      </div>
      <div
        v-if="props.facetsToDisplay.lensTech"
      >
        <ListRefinement
          :attribute="props.facetsToDisplay.lensTech"
          :title="props.facetsToDisplay.lensTech.filterGroupDisplayName"
          :group-value="props.facetsToDisplay.lensTech.filterGroupValue"
          :selected="
            activeFilterGroup ===
              props.facetsToDisplay.lensTech.filterGroupValue
          "
          dropdown-positioning="sidebar"
          @toggle-active-filter-group="toggleActiveFilterGroup"
        />
      </div>
      <div
        v-if="props.facetsToDisplay.name"
      >
        <ListRefinement
          :attribute="props.facetsToDisplay.name"
          :title="props.facetsToDisplay.name.filterGroupDisplayName"
          :group-value="props.facetsToDisplay.name.filterGroupValue"
          :selected="
            activeFilterGroup === props.facetsToDisplay.name.filterGroupValue
          "
          dropdown-positioning="sidebar"
          @toggle-active-filter-group="toggleActiveFilterGroup"
        />
      </div>
      <div
        v-if="props.facetsToDisplay.faceSize"
      >
        <ListRefinement
          :attribute="props.facetsToDisplay.faceSize"
          :title="props.facetsToDisplay.faceSize.filterGroupDisplayName"
          :group-value="props.facetsToDisplay.faceSize.filterGroupValue"
          :selected="
            activeFilterGroup ===
              props.facetsToDisplay.faceSize.filterGroupValue
          "
          dropdown-positioning="sidebar"
          @toggle-active-filter-group="toggleActiveFilterGroup"
        />
      </div>
      <div
        v-if="props.facetsToDisplay.partner"
      >
        <ListRefinement
          :attribute="props.facetsToDisplay.partner"
          :title="props.facetsToDisplay.partner.filterGroupDisplayName"
          :group-value="props.facetsToDisplay.partner.filterGroupValue"
          :selected="
            activeFilterGroup ===
              props.facetsToDisplay.partner.filterGroupValue
          "
          dropdown-positioning="sidebar"
          @toggle-active-filter-group="toggleActiveFilterGroup"
        />
      </div>
    </div>
    <div class="FilterFacetsSidebar__footer">
      <VisionButton
        background-colour="gradient"
        class="FilterFacetsSidebar__footer-btn"
        @click="handleFooterButtonClick"
      >
        <template #content>
          <span class="FilterFacetsSidebar__footer-btn-wrapper">
            View&nbsp;<FilterResultsCount />&nbsp;Products
          </span>
        </template>
      </VisionButton>
    </div>
  </VisionSidebar>
</template>

<script setup lang="ts">
import type { FilterGroup } from '~/assets/js/helpers/search/search'

interface Props {
  facetsToDisplay: FilterGroup
  visible: boolean
}

const props = defineProps<Props>()

const activeFilterGroup = ref('')

const emit = defineEmits(['close'])

const pageStore = usePageStore()

function toggleActiveFilterGroup(filterGroup: string) {
  if (activeFilterGroup.value === filterGroup) {
    activeFilterGroup.value = ''
    return
  }

  activeFilterGroup.value = filterGroup
}

function handleBlockBodyScroll(value) {
  pageStore.toggleBlockBodyScroll(value)
}

function handleFooterButtonClick() {
  emit('close')
}
</script>

<style lang="postcss">
.FilterFacetsSidebar__body-wrapper {
  @apply px-4 pb-28;
}

.FilterFacetsSidebar__footer {
  @apply global-wrapper fixed left-0 block bottom-14 md:bottom-6 w-full z-[2] text-center;
}

.FilterFacetsSidebar__footer-btn {
  @apply mx-auto w-full max-w-sm inline-flex;
}

.FilterFacetsSidebar__footer-btn-wrapper {
  @apply inline-flex;
}
</style>